import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'StateCode' })
export class statecodetoname implements PipeTransform {
    constructor(){
    }
    transform(items: any, countryCode: string, stateCode: string): any{
        if (items !== undefined && items !== null && items !== ''){
        try{
         
            const convertedCountry = JSON.parse(localStorage.CountryCollection).filter(data=>
                             data.CountryCode == countryCode );


                if(convertedCountry.length > 0){
                 return   convertedCountry[0].states.filter(country=> country.StateCode == stateCode)[0].StateName;
                }

                           //  return convertedCountry;
            }catch(ex){
                console.log(ex + '-----' + items);
            }
       }
    return items;
    }
}


// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_pipe/state.ts